import { render, staticRenderFns } from "./SoTienNganHang.vue?vue&type=template&id=28cebe2a"
import script from "./SoTienNganHang.vue?vue&type=script&lang=js"
export * from "./SoTienNganHang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports